import { render, staticRenderFns } from "./ExternalLinkModal.vue?vue&type=template&id=9f5af7d4&scoped=true"
import script from "./ExternalLinkModal.vue?vue&type=script&lang=js"
export * from "./ExternalLinkModal.vue?vue&type=script&lang=js"
import style0 from "./ExternalLinkModal.vue?vue&type=style&index=0&id=9f5af7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5af7d4",
  null
  
)

export default component.exports